import React from 'react';
import 'react-spring-bottom-sheet/dist/style.css'
import styled from 'styled-components';
import {Button} from "@chakra-ui/react";
import Sheet, {Header, Title} from "./sheet";
import {useSheetModal} from "../test/ModalContext";
import {useLoggedIn} from "../../store";
import SignupPromptSheet from "./signup_prompt";
import ProSignupSheet from "./pro/pro_signup";

const SupportUsSheet = styled(({className, onClose}) => {

    const loggedIn = useLoggedIn();
    const { openModal } = useSheetModal();

    const handlePro = () => {

        if (loggedIn) {

            const modalContent = ({ handleCloseModal }) => (
                <Sheet onClose={() => handleCloseModal() } padding={"header"}><ProSignupSheet onClose={() => handleCloseModal() } /></Sheet>
            );

            openModal(modalContent);

        } else {

            const modalContent = ({ handleCloseModal }) => (
                <Sheet onClose={() => handleCloseModal() } padding={"header"}><SignupPromptSheet onClose={() => handleCloseModal() } /></Sheet>
            );

            openModal(modalContent);

        }

    };

    const handleOtherOptions = () => {
        onClose();
        window.location.href = "https://contribute.scored.co/";
    };

        return (
            <div className={className}>

                <Header>
                    <Title>Support Us</Title>
                </Header>

                <p>
                    Consider subscribing to Pro, or making a direct contribution.
                </p>

                <Button variant="blue" mb={2} mt={6} width={"100%"} onClick={handlePro}>
                    Subscribe to Pro
                </Button>
                <Button variant="grey" width={"100%"} onClick={handleOtherOptions}>
                    Other options
                </Button>

            </div>
        );
    }
)`
  p {
    font-size: 17px;
  }
`;

export default SupportUsSheet;
